import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import SuccessImage from '../../assets/SucessPayment.png'; // Ensure path is correct

const PaymentSuccess = ({ onNext }) => {
  // Custom function to skip failure screen
  const handleStartTimer = () => {
    onNext(); // go from 4 → 5
    onNext(); // go from 5 → 6
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={3}
      width="100%"
      maxWidth="400px"
      mx="auto"
      textAlign="center"
      mt={8}
    >
      <Box
        component="img"
        src={SuccessImage}
        alt="Payment Success"
        sx={{ width: 100, height: 100 }}
      />

      <Typography
        sx={{
          fontFamily: 'Mulish',
          fontWeight: 600,
          fontSize: '22px',
          lineHeight: '120%',
          color: '#261863',
        }}
      >
        Transfer Successfully
      </Typography>

      <Typography
        sx={{
          fontFamily: 'Mulish',
          fontWeight: 400,
          fontSize: '16px',
          lineHeight: '140%',
          color: '#88879C',
          maxWidth: '300px',
        }}
      >
        Your money has been debited successfully
      </Typography>

      <Button
        variant="contained"
        onClick={handleStartTimer}
        sx={{
          width: '100%',
          maxWidth: '350px',
          height: '56px',
          borderRadius: '16px',
          backgroundColor: '#261863',
          color: '#fff',
          fontWeight: 'bold',
          mt: 2,
          '&:hover': {
            backgroundColor: '#1b1450',
          },
        }}
      >
        See Charging Timer
      </Button>
    </Box>
  );
};

export default PaymentSuccess;
